import type {HubspotFormProps} from 'next-hubspot'
import {useHubspotContext} from 'next-hubspot'
import {useEffect, useRef, useState} from 'react'
import {logger} from 'src/common/logger'

const useCreateHubspotForm = (formProps: HubspotFormProps) => {
  const {isScriptLoaded, scriptError} = useHubspotContext()
  const [formCreated, setFormCreated] = useState(false)
  const formIdRef = useRef(formProps.locale)

  // Create the form when the script is loaded
  useEffect(() => {
    if (isScriptLoaded && (!formCreated || formIdRef.current !== formProps.formId)) {
      try {
        window.hbspt.forms.create(formProps)
        setFormCreated(true)
      } catch (e) {
        setFormCreated(false)
        logger.error('Error creating HubSpot form', undefined, e)
      }
    }
    // Don't include 'formProps' here to avoid rerenders
  }, [isScriptLoaded, formCreated, setFormCreated, formProps])

  return {loaded: isScriptLoaded, formCreated, error: scriptError}
}

export default useCreateHubspotForm
